$(function() {

    let line_item_id = null;

    $('body').on('show.bs.modal', '#lineItemMetaModal', function() {

        $('#lineItemMetaModal .loading-modal').show();
        $('#lineItemMetaModal .updating-modal').hide();

        $('#lineItemMetaModal form')[0].reset();

        tinymce.remove('#lineItemBrief');
    });

    $('body').on('hidden.bs.modal', '#lineItemMetaModal', function() {

        $('#lineItemMetaModal .loading-modal').hide();
        $('#lineItemMetaModal .updating-modal').hide();

        tinymce.remove('#lineItemBrief');
    });

    $('body').on('click', '.item-meta-button', function() {

        line_item_id = $(this).data('id');

        $('#lineItemMetaModal').modal('show');

        $.ajax({
            url: '/artroom/lineitem/' + line_item_id,
            type: 'get',

            dataType: 'json',
            data: {},
            success: function (result) {

                $('#lineItemMetaModal .loading-modal').hide();
                $('#lineItemMetaModal #active-line').val(line_item_id);

                $('#lineItemMetaModal input[name="reference"]').attr('placeholder', result.default_reference);

                $('#lineItemMetaModal .line-notes-files').html(result.body);

                if (result.meta_data) {
                    $('#lineItemMetaModal input[name="reference"]').val(result.meta_data.reference);
                    $('#lineItemMetaModal input[name="placement"]').val(result.meta_data.placement);
                    $('#lineItemMetaModal select[name="artwork"]').val(result.meta_data.artwork);
                }

                tinymce.init({
                    selector: '#lineItemBrief',
                    height: $('#lineItemBrief').data('height') ?? 120,
                    menubar: false,
                    statusbar: false,
                    default_text_color: 'red',
                    plugins: [
                        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                        'searchreplace wordcount visualblocks visualchars code fullscreen',
                    ],
                    toolbar1: 'undo redo | insert | bold italic | bullist numlist | link | codesample',
                    content_css: []
                });

                const dropZone = new Dropzone("#lineItemAttachments", {
                    url: "/documents/upload/supplied/" + line_item_id,
                    dictResponseError: 'Error uploading file!',
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    }
                });

                dropZone.on("addedfile", file => {
                    $('#line-meta-files table tbody').append(`<tr>
                            <td>${file.name}</td>
                            <td>${file.size}</td>
                        </tr>`)
                });

                feather.replace();
            }
        });

    });

    $('body').on('click', '#lineItemMetaModal .update-line-item', function() {

        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
            }
        });

        tinymce.triggerSave();

        $('#lineItemMetaModal .modal-cover.modal-updating').show();

        let $data = $("#lineItemMetaModal form").serialize();

        $.ajax({
            url: "/artroom/lineitem/" + line_item_id,
            type: 'post',
            dataType: 'json',
            data: $data,
            success: function (result) {

                $('meta[name="csrf-token"]').attr('content', result.token);

                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': result.token
                    }
                });

                if (result.status === 'success') {

                    $('#lineItemMetaModal').modal('hide');
                    $('#lineItemMetaModal .modal-cover.modal-updating').hide();

                    line_item_id = null;

                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    });

                    Toast.fire({
                        icon: 'success',
                        title: result.message
                    })

                } else {

                    $('#lineItemMetaModal .modal-cover.modal-updating').hide();

                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000,
                        timerProgressBar: true,
                    });

                    Toast.fire({
                        icon: 'error',
                        title: result.message
                    })
                }

            },
            error: function (xhr, status, error) {
                // This will be general errors //

                $('#sendProductionModal .modal-cover').hide();
            }
        });
    });
});